/**
 * Loop over the conditions attribute object. Return true if block has conditions.
 *
 * @param {Object} conditions Conditions object of block attributes.
 *
 * @return {boolean} hasCondition true or false.
 */
export function isLegacyConditions(conditions) {
  if (!conditions) {
    return false;
  }

  let hasCondition = false;

  const conditionKeys = Object.keys(conditions);

  // eslint-disable-next-line no-restricted-syntax
  for (const conditionKey of conditionKeys) {
    // Check for object as key value.
    if (conditions[conditionKey] && typeof conditions[conditionKey] === 'object') {
      const conditionsObject = conditions[conditionKey];

      if (Array.isArray(conditionsObject) && conditionsObject.length) {
        hasCondition = true;
        break;
      } else if (conditionKey === 'postMeta' && conditionsObject.key) {
        hasCondition = true;
        break;
      }
    } else if (conditions[conditionKey].length && typeof conditions[conditionKey] === 'string') {
      hasCondition = true;
      break;
    } else if (conditions[conditionKey] === true && typeof conditions[conditionKey] === 'boolean') {
      hasCondition = true;
      break;
    }
  }

  return hasCondition;
}

/**
 * Conditional Blocks Logo.
 */
export function ConditionalBlocksLogo({ width = 20, className = '' }) {
  return (
    <svg
      className={'conditional-blocks-svg ' + className}
      width={width}
      viewBox="0 0 296 358"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M153.006 233.896V108.708C153.006 101.03 146.789 94.7988 139.097 94.7988H13.9095C6.21763 94.7988 0 101.03 0 108.708V233.896C0 241.574 6.21763 247.805 13.9095 247.805H139.097C146.789 247.805 153.006 241.574 153.006 233.896ZM83.4575 206.076H55.6379C47.946 206.076 41.7284 199.845 41.7284 192.166C41.7284 184.488 47.946 178.257 55.6379 178.257H83.4575C91.1493 178.257 97.367 184.488 97.367 192.166C97.367 199.845 91.1493 206.076 83.4575 206.076ZM97.367 164.347H55.6379C47.946 164.347 41.7284 158.116 41.7284 150.437C41.7284 142.759 47.946 136.528 55.6379 136.528H97.367C105.059 136.528 111.276 142.759 111.276 150.437C111.276 158.116 105.059 164.347 97.367 164.347Z"
        fill="#2F2F2F"
      />
      <path
        d="M66.8594 71.8152C96.0928 43.5248 162.002 38.3966 204.247 56.3842L199.605 57.9365C191.63 60.5994 187.324 69.2129 189.987 77.1874C192.102 83.5639 198.037 87.5964 204.414 87.5964C206.011 87.5964 207.624 87.3375 209.222 86.8053L243.706 75.3156C243.873 75.2549 243.995 75.118 244.162 75.0566C245.06 74.7221 245.821 74.1286 246.658 73.6107C247.586 73.0479 248.545 72.5606 249.306 71.8302C249.443 71.7082 249.611 71.6625 249.748 71.5413C250.265 71.0084 250.478 70.3393 250.904 69.7458C251.558 68.8634 252.228 68.0416 252.685 67.0372C253.095 66.1242 253.247 65.1654 253.461 64.2067C253.674 63.263 253.948 62.3806 253.978 61.4218C254.024 60.2955 253.78 59.2304 253.582 58.1198C253.445 57.435 253.551 56.7502 253.323 56.0654L238.105 10.4116C235.442 2.43714 226.92 -1.88428 218.854 0.7936C210.896 3.44152 206.589 12.0701 209.236 20.0445L211.413 26.5274C158.03 5.86117 83.2947 13.561 45.691 49.947C39.6647 55.7757 39.4971 65.4237 45.3407 71.465C51.2001 77.492 60.8181 77.6746 66.8594 71.8152Z"
        fill="#2F2F2F"
      />
      <path
        d="M228.187 285.612C198.954 313.903 133.045 319.031 90.8 301.043L106.627 295.763C114.586 293.115 118.893 284.486 116.245 276.512C113.582 268.553 105.029 264.216 96.994 266.894L51.3402 282.111C51.1576 282.172 51.0513 282.309 50.8837 282.37C49.9249 282.721 49.1181 283.344 48.2357 283.892C47.3683 284.44 46.4702 284.896 45.7398 285.596C45.6028 285.718 45.4352 285.748 45.2982 285.885C44.781 286.418 44.5677 287.087 44.1419 287.68C43.4877 288.563 42.8179 289.385 42.3614 290.389C41.9505 291.302 41.7985 292.261 41.5853 293.219C41.372 294.148 41.098 295.031 41.0681 296.004C41.0224 297.131 41.2657 298.196 41.464 299.306C41.601 299.991 41.4947 300.676 41.7229 301.361L56.9406 347.015C59.0714 353.391 64.9907 357.424 71.3672 357.424C72.9651 357.424 74.578 357.18 76.1915 356.633C84.1503 353.985 88.4574 345.356 85.8095 337.382L83.6331 330.899C102.99 338.386 125.056 342.267 147.244 342.267C186.263 342.267 225.372 330.671 249.356 307.478C255.383 301.65 255.55 292.002 249.707 285.961C243.861 279.936 234.244 279.769 228.187 285.612Z"
        fill="#2F2F2F"
      />
      <path
        d="M284.295 128.113H185.356C179.277 128.113 174.363 133.038 174.363 139.106V238.045C174.363 244.113 179.277 249.037 185.356 249.037H284.295C290.374 249.037 295.287 244.113 295.287 238.045V139.106C295.287 133.038 290.374 128.113 284.295 128.113ZM240.322 216.058H218.335C212.256 216.058 207.342 211.133 207.342 205.065C207.342 198.997 212.256 194.072 218.335 194.072H240.322C246.401 194.072 251.315 198.997 251.315 205.065C251.315 211.133 246.401 216.058 240.322 216.058ZM251.315 183.079H218.336C212.257 183.079 207.343 178.154 207.343 172.086C207.343 166.017 212.257 161.093 218.336 161.093H251.315C257.394 161.093 262.308 166.017 262.308 172.086C262.308 178.154 257.394 183.079 251.315 183.079Z"
        fill="#4E4E4E"
      />
    </svg>
  );
}

export function createUUID4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line eqeqeq,no-bitwise
    const v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const shouldDisplaySeparator = (index, arr) => {
  const currentNumber = index + 1;
  const totalEntries = arr.length ?? 0;

  // Don't display if there's none or only 1.
  if (totalEntries <= 1) {
    return false;
  }

  // Don't display for the last.
  if (currentNumber === totalEntries) {
    return false;
  }
  return true;
};

export const blankCondition = (inheritId = false) => ({
  id: inheritId || createUUID4(),
  type: false,
});

export const blankPreset = (prefilledName) => ({
  id: createUUID4(),
  type: 'preset',
  name: prefilledName,
  conditions: [],
});

export const blankSet = (data) => ({
  id: createUUID4(),
  type: 'set',
  conditions: [],
  ...data,
});

/**
 * Rebuild the format needed to work with Select Multi.
 * This converts the legacy Gutenberg select values for backwards compat.
 */
export const getFormatForMultiSelect = (currentArr) => {
  if (!currentArr) {
    return [];
  }

  const newFormat = [];

  currentArr.forEach((currentVal) => {
    if (typeof currentVal === 'string') {
      newFormat.push({ value: currentVal, label: currentVal });
    } else {
      newFormat.push(currentVal);
    }
  });

  return newFormat;
};

export const formatArrayForSelect = (arr, includeKeyInLabel = false) => {
  if (!arr) {
    return [];
  }

  const newFormat = [];

  for (const key of Object.keys(arr)) {
    newFormat.push({ value: key, label: includeKeyInLabel ? `${key} - ${arr[key]}` : arr[key] });
  }

  return newFormat;
};

/**
 * Helper function to deep merge two objects.
 * @param {object} target
 * @param {object} source
 */
export function deepObjectMerge(target, source) {
  const result = { ...target, ...source };
  const keys = Object.keys(result);

  keys.forEach((key) => {
    const targetProp = target[key];
    const sourceProp = source[key];
    // if two objects are in conflict
    if (typeof targetProp === 'object' && typeof sourceProp === 'object') {
      result[key] = deepObjectMerge(targetProp, sourceProp);
    }
  });

  return result;
}
